"use client"

import { useState } from "react"
import { useAuth0 } from "@auth0/auth0-react"

export const usePostProblem = () => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [success, setSuccess] = useState(false)
  const { getAccessTokenSilently } = useAuth0()
  const apiUrl = process.env.REACT_APP_API_URL

  const postProblem = async (problemData) => {
    try {
      setLoading(true)
      setError(null)
      setSuccess(false)

      const token = await getAccessTokenSilently({
        authorizationParams: {
          audience: process.env.REACT_APP_API_AUDIENCE,
        },
      })

      const response = await fetch(`${apiUrl}/api/Problems`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(problemData),
      })

      if (response.ok) {
        const data = await response.json()
        setSuccess(true)
        return data
      } else {
        console.error("Failed to create problem:", response.statusText)
        setError("Failed to create problem. Please try again later.")
        return null
      }
    } catch (error) {
      console.error("Error creating problem:", error.message)
      setError("Failed to create problem. Please try again later.")
      return null
    } finally {
      setLoading(false)
    }
  }

  return { postProblem, loading, error, success }
}

export default usePostProblem
